import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { serviceurl } from '../constant/constant';

@Injectable({
  providedIn: 'root'
})
export class UserPreferenceService {
  private preferencesSubject = new BehaviorSubject<any>(null);
  public preferences$ = this.preferencesSubject.asObservable();

  constructor(private http: HttpClient) {}

  fetchPreferences(userId: number) {
    return this.http.get(`${serviceurl}api/user/preferences/${userId}/`)
      .subscribe(
        (prefs: {ui_preferences: any}) => {
          this.preferencesSubject.next(prefs?.ui_preferences || {});
        },
        (error) => {
          console.error('Error fetching user preferences', error);
          this.preferencesSubject.next({});
        }
      );
  }

  getPreferences(userId: number): Observable<any> {
    return this.http.get(`${serviceurl}api/user/preferences/${userId}/`);
  }

  updatePreference(userId: number, flagName: string, value: any) { 
    const payload = {
      ui_preferences: {
        [flagName]: value
      }
    };

    // Optimistic update
    const currentPrefs = this.preferencesSubject.value || {};
    this.preferencesSubject.next({ ...currentPrefs, [flagName]: value });

    return this.http.patch(`${serviceurl}api/user/preferences/${userId}/`, payload)
      .pipe(
        tap((updatedPrefs: any) => {
          this.preferencesSubject.next(updatedPrefs?.ui_preferences || {});
        })
      );
  }
}
